<template>
  <div class="non-blocking-modal">
    <div class="row mb-2">
      <div class="col">
        <h4>Customer note</h4>
        <div class="l-modal-close"
             @click="$emit('close')"
        >
          <button class="btn btn-close"><span class="mod-icon-close opacity-50" /></button>
        </div>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col">
        <div class="select-wrap">
          <label>Note</label>
          <textarea v-model="customerNoteNew"
                    :disabled="statusName === 'Canceled' ||
                      (statusName === 'Completed' && !$_can('customers.notes.edit')) ||
                      statusName === 'Closed' ||
                      statusName === 'No Availability' ||
                      statusName === 'Booked'"
                    cols="30" rows="10"
                    class="select-wrap-textarea form-control"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <error-field :errors="errors" field="note" />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <button v-if="statusName !== 'Canceled' &&
                  (statusName !== 'Completed' || $_can('customers.notes.edit')) &&
                  statusName !== 'Closed' &&
                  statusName !== 'No Availability' &&
                  statusName !== 'Booked'"
                type="button"
                class="btn btn-primary pull-right ld-ext-right"
                @click="saveCustomerNote"
                :disabled="loading"
        >
          Save
          <div class="ld ld-ball ld-flip" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import Errors from '../classes/Errors';
import ErrorField from './ErrorField';

export default {
  name: 'CustomerNote',
  label: { type: String, default: 'Browse' },
  components: {
    ErrorField,
  },
  props: {
    customerNote: {
      type: String,
      default: '',
    },
    model: {
      type: String,
      required: true,
      validator(value) {
        return ['leads', 'jobs'].indexOf(value) !== -1;
      },
    },
    modelId: {
      type: Number,
      required: true,
    },
    noteId: {
      type: Number,
      default: null,
    },
    userId: {
      type: Number,
      default: null,
    },
    statusName: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    customerNoteNew: '',
    errors: new Errors(),
    loading: false,
  }),
  mounted() {
    this.customerNoteNew = this.customerNote;
  },
  methods: {
    saveCustomerNote() {
      this.loading = true;
      if (this.noteId) {
        axios
          .put(`${this.model}/${this.modelId}/customer-note/${this.noteId}`, {
            note: this.customerNoteNew,
          })
          .then(res => {
            toastr.success('Successfully saved customer note');
            this.$emit('ok', () => {
              this.loading = false;
              return res.data.data;
            });
          })
          .catch(err => {
            this.errors.record(err.response.data.error);
            this.loading = false;
          });
      } else {
        axios
          .post(`${this.model}/${this.modelId}/customer-note`, {
            note: this.customerNoteNew,
            user_id: this.userId,
          })
          .then(res => {
            this.$emit('ok', () => {
              toastr.success('Successfully saved customer note');
              this.loading = false;
              return res.data.data;
            });
          })
          .catch(err => {
            this.errors.record(err.response.data.error);
            this.loading = false;
          });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/CustomerNote.vue